import { useState } from "react";

import { Button, Text } from "@alpacahq/ui/old";

import { useGetFPSLTierRates } from "~/v2/api/hooks/useGetFPSL";
import { PDFAgreementModal } from "~/v2/components/form";
import { MSLA_AGREEMENT_URL } from "../../entityOnboarding/constants";
import { FpslBenefits } from "../../fpslOnboarding/FpslBenefits";
import { FpslEliteDisclaimer } from "../../fpslOnboarding/FpslEliteDisclaimer";
import { Back } from "../back";
import { getFpslPreference, setFpslPreference } from "../fpslPreference";
import type { StepProps } from "../session";
import { FpslAgreementBox } from "./FpslAgreementBox";

const StockLending = ({ session }: StepProps) => {
  const { account } = session;

  const previousPreference = getFpslPreference(account.id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(
    previousPreference === true,
  );

  const { eliteRate, defaultRate } = useGetFPSLTierRates({
    accountID: account.id,
    product: "live",
  });

  const onAgree = () => {
    setIsAgreementAccepted(true);
    setFpslPreference(account.id, true);
    setIsModalOpen(false);
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex grow flex-col gap-4">
        <div>
          <h2 className="font-bold text-lg">Stock Lending Program</h2>
          <Text className="mt-1 text-gray-600">
            Enroll to earn extra income by lending out eligible stocks or ETFs
            in your account. You&apos;ll still own your investments and can sell
            them anytime.
          </Text>
        </div>

        <FpslBenefits eliteRate={eliteRate}>
          <FpslEliteDisclaimer
            eliteRate={eliteRate}
            defaultRate={defaultRate}
          />
        </FpslBenefits>

        <FpslAgreementBox
          isAccepted={isAgreementAccepted}
          onOpen={() => setIsModalOpen(true)}
        />

        <PDFAgreementModal
          isOpen={isModalOpen}
          title="Master Securities Lending Agreement"
          url={MSLA_AGREEMENT_URL}
          onCancel={() => setIsModalOpen(false)}
          onAgree={onAgree}
          hasAgreed={isAgreementAccepted}
        />
      </div>

      <div className="mt-8 flex justify-between">
        <Back session={session} />
        <Button
          variant={isAgreementAccepted ? "v2/filled" : "secondary"}
          onClick={() => session.completeFpslStep(isAgreementAccepted)}
        >
          {isAgreementAccepted ? "Continue" : "Skip for now"}
        </Button>
      </div>
    </div>
  );
};

export default StockLending;
